<template>
    <div class="container">
        <button class="twitter-login-button" @click="loginWithTwitter">
            <svg style="margin-right: 10px;" width="30px" enable-background="new 0 0 56.693 56.693" id="Layer_1" version="1.1" viewBox="0 0 56.693 56.693" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M28.348,5.157c-13.6,0-24.625,11.027-24.625,24.625c0,13.6,11.025,24.623,24.625,24.623c13.6,0,24.623-11.023,24.623-24.623  C52.971,16.184,41.947,5.157,28.348,5.157z M40.752,24.817c0.013,0.266,0.018,0.533,0.018,0.803c0,8.201-6.242,17.656-17.656,17.656  c-3.504,0-6.767-1.027-9.513-2.787c0.486,0.057,0.979,0.086,1.48,0.086c2.908,0,5.584-0.992,7.707-2.656  c-2.715-0.051-5.006-1.846-5.796-4.311c0.378,0.074,0.767,0.111,1.167,0.111c0.566,0,1.114-0.074,1.635-0.217  c-2.84-0.57-4.979-3.08-4.979-6.084c0-0.027,0-0.053,0.001-0.08c0.836,0.465,1.793,0.744,2.811,0.777  c-1.666-1.115-2.761-3.012-2.761-5.166c0-1.137,0.306-2.204,0.84-3.12c3.061,3.754,7.634,6.225,12.792,6.483  c-0.106-0.453-0.161-0.928-0.161-1.414c0-3.426,2.778-6.205,6.206-6.205c1.785,0,3.397,0.754,4.529,1.959  c1.414-0.277,2.742-0.795,3.941-1.506c-0.465,1.45-1.448,2.666-2.73,3.433c1.257-0.15,2.453-0.484,3.565-0.977  C43.018,22.849,41.965,23.942,40.752,24.817z"/></svg>
            <p>{{$t('login.buttons.login_with_twitter')}}</p>
        </button>


    </div>
</template>
  
<script>
import { RestResource } from '../../modules/rest/RestResource';

export default {
    data() {
        return {
            loginWithTwitterRequest: false,
        }
    },
    computed: {
        redirectUrl() {
            return RestResource.ApiWrite + '/social_login/twitter/redirect';
        }
    },
    methods: {
        loginWithTwitter() {
            window.location.href = this.redirectUrl;
        },
        closeModal() {
            this.loginWithTwitterRequest = false;
        }
    }
}
</script>
  
<style scoped lang="scss">
@import "@/styles/variables.scss";

.container {
    text-align: center;
}

.twitter-login-button {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0px 20px;
    background-color: var(--pallete_main_color);
    color: #fff;
    border: none;
    border-radius: 30px;
    cursor: pointer;
    font-size: 16px;
    transition: background-color 0.3s;
}

.twitter-login-button:hover {
    // background-color: #2B8CC4;
    filter: brightness(1.1);
}

.twitter-icon {
    width: 20px;
    height: 20px;
    margin-right: 10px;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal {
    background: #fff;
    padding: 20px;
    border-radius: 5px;
    position: relative;
}

.close {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  font-size: 20px;
  color: #aaa;
}
</style>
  